import {
    getQueryString,
    invokeApp,
    setStorage,
    getStorage,
    clearStorage,
    removeStorage,
} from "@/util";
import { 
	Toast, 
	Dialog, 
	Loading,
	Popup,
	Radio,
} from "vant";
const loginMixin = {
	data() {
		return {
		}
	},
    created() {
		// login
		if(getQueryString('code'))
		{
			this.userInfo(getQueryString('code'))
		}
	},
	methods: {
		logout(){
			Dialog.confirm({
			        title: null,
			        message: this.$t("确定退出登录？"),
			        confirmButtonText: this.$t("确定"),
			        cancelButtonText: this.$t("取消"),
			    })
			    .then(() => {
					var lang = this.$common.lang
					var changeLang = this.$common.changeLang
					var proxyCode = getStorage('proxy_code')
					clearStorage()
					setStorage('lang', lang)
					setStorage('changeLang', changeLang)
					setStorage('proxy_code', proxyCode)
					var url = window.location.href
					url = url.replace(/access_token=.*?\&/, '&')
					url = url.replace(/\&access_token=.*/, '')
					url = url.replace(/\?access_token=.*/, '')
					window.location.href=url
					location.reload()
			    })
			    .catch(() => {
			    })
		},
		login(){
			if(this.$common.inWechat)
			{
				Toast(this.$t('点击右上角的按钮,选择在浏览器中打开'));
				return false
			}
			var that = this
			this.$fetch(this.$common.apis.userCode).then(res => {
				var appname = 'what'
				var returnUrl = window.location.href
				if(returnUrl.indexOf('#/?')){
					returnUrl += '&code='+res.code+'&h5=1'
				}else{
					returnUrl += '?code='+res.code+'&h5=1'
				}
				var url = that.assembleLoginUrl(res.code, appname, returnUrl)
				window.location.href=url
				setTimeout(function() {
					Toast(that.$t('已为你打开新的页面, 本页面请关闭'))
				}, 2000)
			})
		},
		assembleLoginUrl(code, appname, returnUrl) {
			var url = this.$common.apis.login.replace('{logo}', encodeURIComponent(this.$common.logoUrl)).replace('{appname}', encodeURIComponent(appname)).replace('{code}', encodeURIComponent(code)).replace('{return_url}', encodeURIComponent(returnUrl))
			return url
		},
		userInfo(key) {
			var userInfo = getStorage('user_info')
			if(userInfo == null){
				return null
			}
			if(key == 'username'){
				return userInfo.email ? userInfo.email : userInfo.mobile
			}
			if(key == 'avatar'){
				return this.cdn(userInfo[key])
			}
			if(userInfo[key] != undefined){
				return userInfo[key]
			}
			// var that = this
			// var url = this.$common.apis.info.replace('{code}', code)
			// this.$fetch(url).then(res => {
			// 	if (res.access_token == undefined) {
			// 		// 超时处理,很难触发
			// 		var lang = getStorage('lang') || that.$common.lang
			// 		clearStorage()
			// 		setStorage('lang', lang)
			// 		that.$common.lang = lang
			// 	}
			// 	setStorage('access_token', res.access_token)
			// 	that.$common.accessToken = res.access_token
			// 	that.$common.userInfo = res
			// 	var url = window.location.href
			// 	url = url.replace(/code=.*?\&/, '&')
			// 	url = url.replace(/\&code=.*/, '')
			// 	url = url.replace(/\?code=.*/, '')
			// 	window.location.href=url
			// 	location.reload()
			// })
		},
	}
}
export default loginMixin